import { setupFormState } from '@/components/form/tidal-form'

import { LanguageAndFormatsFormValues } from './typings'

export const form = setupFormState<LanguageAndFormatsFormValues>({
  id: 'LanguageAndFormatsForm',
  initialValues: {
    id: '',
    distanceFormat: 'IMPERIAL',
    dateFormat: 'DMMMY',
    timeFormat: 'HH:mm',
    language: 'en',
    currency: 'USD',
  },
})
